module.exports = __webpack_public_path__ + "b4f0abc6ec0de07868daae5973a9b4e7.svg";